export const NOTIFICATION_ICON = '/icon.svg'

export type DesktopPermission = NotificationPermission | 'unsupported'

export interface DesktopAlert {
  title: string
  body: string
  tag: string
  onClick: () => void
}

const supported = (): boolean => typeof Notification !== 'undefined'

export const desktopPermission = (): DesktopPermission => (supported() ? Notification.permission : 'unsupported')

export const requestDesktopPermission = async (): Promise<DesktopPermission> =>
  supported() ? Notification.requestPermission().catch(() => Notification.permission) : 'unsupported'

export const showDesktopNotification = (alert: DesktopAlert): boolean => {
  if (desktopPermission() !== 'granted' || !document.hidden) return false
  try {
    const notification = new Notification(alert.title, { body: alert.body, tag: alert.tag, icon: NOTIFICATION_ICON })
    notification.addEventListener('click', () => {
      window.focus()
      alert.onClick()
      notification.close()
    })
    return true
  } catch {
    return false
  }
}
